import { useMemo } from 'react'

import { RealtyImage } from 'shared/api/kyrgyzstan/search'
import GhostImage from 'shared/images/ghost.png'
import { Carousel } from 'shared/ui/carousel'

import s from './styles.module.scss'

interface ImageSectionProps {
  images: RealtyImage[]
  onOpenGallery?: () => void
}

export const ImageSection = ({ images, onOpenGallery }: ImageSectionProps) => {
  const handleOpenGallery = () => {
    onOpenGallery?.()
  }

  const preparedImages = useMemo(() => {
    return images.map((image) => ({
      id: image.id,
      image: image.image_url,
      image_fullpath: image.image_url,
    }))
  }, [images])

  return (
    <div
      className={s.container}
      onClick={handleOpenGallery}
    >
      <Carousel
        dotsVariant="custom"
        images={preparedImages}
        errorImage={GhostImage}
        showCounter
        size="aspect"
      />
    </div>
  )
}
